import "./static.9a36735d.js";
import "./static.6c6d5700.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4a5c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4a5c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1WtUB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $16a2691a499505cd$export$2e2bcd8739ae039; });

var $fkb2R = parcelRequire("fkb2R");

var $dqDIK = parcelRequire("dqDIK");

var $h0m4j = parcelRequire("h0m4j");

var $USTED = parcelRequire("USTED");
const $16a2691a499505cd$var$TIMEOUT = 150;
const $16a2691a499505cd$var$CANCEL_RESET_MESSAGE = 'Password Not Changed';
const $16a2691a499505cd$var$SUCCESS_RESET_MESSAGE = 'Password Changed Successfully';
const $16a2691a499505cd$var$INVALID_ERROR = 'Invalid Username or Password';
var $16a2691a499505cd$export$2e2bcd8739ae039 = {
    __name: 'loginPage',
    setup (__props, { expose: __expose }) {
        __expose();
        const error = (0, $fkb2R.ref)({
            isError: false,
            userField: false,
            passField: false,
            text: ''
        });
        const JSLoad = (0, $fkb2R.ref)(true);
        const username = (0, $fkb2R.ref)('');
        const password = (0, $fkb2R.ref)('');
        const submitting = (0, $fkb2R.ref)(false);
        const success = (0, $fkb2R.ref)({
            isSuccess: false,
            text: ''
        });
        const resetError = ()=>{
            error.value = {
                isError: false,
                userField: false,
                passField: false,
                text: ''
            };
        };
        const resetSuccess = ()=>{
            success.value = {
                isSuccess: false,
                text: ''
            };
        };
        const resetAll = ()=>{
            resetError();
            resetSuccess();
            username.value = '';
            password.value = '';
            submitting.value = false;
        };
        const handleLogin = ()=>{
            const req = new XMLHttpRequest();
            req.open('POST', '/login', true);
            req.timeout = $16a2691a499505cd$var$TIMEOUT * 1000;
            req.setRequestHeader('Content-Type', 'application/json');
            req.onreadystatechange = ()=>{
                if (req.readyState === 4) {
                    if (req.status === 200 || req.status === 201) {
                        window.location.reload();
                        submitting.value = false;
                    } else {
                        resetAll();
                        error.value = {
                            isError: true,
                            text: $16a2691a499505cd$var$INVALID_ERROR
                        };
                    }
                }
            };
            const data = {
                username: username.value,
                password: password.value
            };
            req.send(JSON.stringify(data));
        };
        const submit = ()=>{
            submitting.value = true;
            resetError();
            resetSuccess();
            if (username.value === '' || password.value === '') {
                error.value.isError = true;
                success.value.isSuccess = false;
                if (username.value === '') error.value.userField = true;
                if (password.value === '') error.value.passField = true;
                submitting.value = false;
            } else handleLogin();
        };
        const checkParam = ()=>{
            const params = window.location.search;
            if (params.includes('?')) {
                const query = params.split('=');
                if (query[0] === '?success' && query[1] === 'true') {
                    success.value.isSuccess = true;
                    success.value.text = $16a2691a499505cd$var$SUCCESS_RESET_MESSAGE;
                } else if (query[0] === '?success' && query[1] === 'false') {
                    error.value.isError = true;
                    error.value.text = $16a2691a499505cd$var$CANCEL_RESET_MESSAGE;
                }
            }
        };
        if (window.location.pathname !== '/login') window.location.href = '/login';
        resetAll();
        checkParam();
        const __returned__ = {
            TIMEOUT: $16a2691a499505cd$var$TIMEOUT,
            CANCEL_RESET_MESSAGE: $16a2691a499505cd$var$CANCEL_RESET_MESSAGE,
            SUCCESS_RESET_MESSAGE: $16a2691a499505cd$var$SUCCESS_RESET_MESSAGE,
            INVALID_ERROR: $16a2691a499505cd$var$INVALID_ERROR,
            error: error,
            JSLoad: JSLoad,
            username: username,
            password: password,
            submitting: submitting,
            success: success,
            resetError: resetError,
            resetSuccess: resetSuccess,
            resetAll: resetAll,
            handleLogin: handleLogin,
            submit: submit,
            checkParam: checkParam,
            ref: $fkb2R.ref,
            get Modal () {
                return 0, $dqDIK.Modal;
            },
            get person_square () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($h0m4j));
            },
            get shield_lock_fill () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($USTED));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("h0m4j", function(module, exports) {
module.exports = $parcel$resolve("a7Yvi");

});

parcelRegister("USTED", function(module, exports) {
module.exports = $parcel$resolve("1WStY");

});


parcelRegister("5abBZ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $3c26e4c0252b9aca$export$b3890eb0ae9dca99; });

var $fkb2R = parcelRequire("fkb2R");
const $3c26e4c0252b9aca$var$_hoisted_1 = {
    class: "row justify-content-center"
};
const $3c26e4c0252b9aca$var$_hoisted_2 = {
    class: "col col-md-12 text-center text-danger my-2"
};
const $3c26e4c0252b9aca$var$_hoisted_3 = {
    class: "col col-md-12 text-center text-primary my-2"
};
const $3c26e4c0252b9aca$var$_hoisted_4 = {
    class: "form-group"
};
const $3c26e4c0252b9aca$var$_hoisted_5 = {
    class: "input-group mb-4 mt-3"
};
const $3c26e4c0252b9aca$var$_hoisted_6 = {
    class: "input-group-text",
    id: "basic-addon1"
};
const $3c26e4c0252b9aca$var$_hoisted_7 = [
    "src"
];
const $3c26e4c0252b9aca$var$_hoisted_8 = {
    class: "input-group my-4"
};
const $3c26e4c0252b9aca$var$_hoisted_9 = {
    class: "input-group-text",
    id: "basic-addon1"
};
const $3c26e4c0252b9aca$var$_hoisted_10 = [
    "src"
];
const $3c26e4c0252b9aca$var$_hoisted_11 = {
    class: "d-flex justify-content-center"
};
const $3c26e4c0252b9aca$var$_hoisted_12 = [
    "disabled"
];
const $3c26e4c0252b9aca$var$_hoisted_13 = [
    "hidden"
];
function $3c26e4c0252b9aca$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $fkb2R.openBlock)(), (0, $fkb2R.createElementBlock)("div", {
        class: (0, $fkb2R.normalizeClass)([
            {
                'dShow': $setup.JSLoad
            },
            "container-fluid border rounded-lg border-dark w-25 mt-5 bg-white dNone"
        ])
    }, [
        _cache[9] || (_cache[9] = (0, $fkb2R.createElementVNode)("div", {
            class: "row justify-content-center mt-3"
        }, [
            (0, $fkb2R.createElementVNode)("h1", {
                class: "col col-md-12 text-center"
            }, "Welcome to Unravel")
        ], -1)),
        _cache[10] || (_cache[10] = (0, $fkb2R.createElementVNode)("div", {
            class: "row justify-content-center"
        }, [
            (0, $fkb2R.createElementVNode)("h2", {
                class: "col col-md-12 text-center"
            }, "Please Login")
        ], -1)),
        (0, $fkb2R.createElementVNode)("div", $3c26e4c0252b9aca$var$_hoisted_1, [
            (0, $fkb2R.withDirectives)((0, $fkb2R.createElementVNode)("div", null, [
                (0, $fkb2R.createElementVNode)("h3", $3c26e4c0252b9aca$var$_hoisted_2, (0, $fkb2R.toDisplayString)($setup.error.text), 1)
            ], 512), [
                [
                    (0, $fkb2R.vShow),
                    $setup.error.isError && $setup.error.text !== ''
                ]
            ]),
            (0, $fkb2R.withDirectives)((0, $fkb2R.createElementVNode)("div", null, [
                (0, $fkb2R.createElementVNode)("h3", $3c26e4c0252b9aca$var$_hoisted_3, (0, $fkb2R.toDisplayString)($setup.success.text), 1)
            ], 512), [
                [
                    (0, $fkb2R.vShow),
                    $setup.success.isSuccess
                ]
            ]),
            (0, $fkb2R.withDirectives)((0, $fkb2R.createElementVNode)("div", null, [
                ..._cache[4] || (_cache[4] = [
                    (0, $fkb2R.createElementVNode)("h3", {
                        class: "col col-md-12 my-5"
                    }, null, -1)
                ])
            ], 512), [
                [
                    (0, $fkb2R.vShow),
                    (!$setup.error.isError || $setup.error.text === '') && !$setup.success.isSuccess
                ]
            ])
        ]),
        (0, $fkb2R.createElementVNode)("form", null, [
            (0, $fkb2R.createElementVNode)("div", $3c26e4c0252b9aca$var$_hoisted_4, [
                (0, $fkb2R.createElementVNode)("div", $3c26e4c0252b9aca$var$_hoisted_5, [
                    (0, $fkb2R.createElementVNode)("span", $3c26e4c0252b9aca$var$_hoisted_6, [
                        (0, $fkb2R.createElementVNode)("img", {
                            src: $setup.person_square,
                            alt: ""
                        }, null, 8, $3c26e4c0252b9aca$var$_hoisted_7)
                    ]),
                    (0, $fkb2R.withDirectives)((0, $fkb2R.createElementVNode)("input", {
                        type: "text",
                        class: (0, $fkb2R.normalizeClass)([
                            "form-control",
                            {
                                'is-invalid': $setup.error.isError && $setup.error.userField
                            }
                        ]),
                        placeholder: "Username",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.username = $event),
                        onKeyup: _cache[1] || (_cache[1] = (0, $fkb2R.withKeys)(($event)=>$setup.submit(), [
                            "enter"
                        ]))
                    }, null, 34), [
                        [
                            (0, $fkb2R.vModelText),
                            $setup.username
                        ]
                    ]),
                    _cache[5] || (_cache[5] = (0, $fkb2R.createElementVNode)("div", {
                        class: "invalid-feedback"
                    }, " Please provide a username. ", -1))
                ]),
                (0, $fkb2R.createElementVNode)("div", $3c26e4c0252b9aca$var$_hoisted_8, [
                    (0, $fkb2R.createElementVNode)("span", $3c26e4c0252b9aca$var$_hoisted_9, [
                        (0, $fkb2R.createElementVNode)("img", {
                            src: $setup.shield_lock_fill,
                            alt: ""
                        }, null, 8, $3c26e4c0252b9aca$var$_hoisted_10)
                    ]),
                    (0, $fkb2R.withDirectives)((0, $fkb2R.createElementVNode)("input", {
                        type: "password",
                        class: (0, $fkb2R.normalizeClass)([
                            "form-control",
                            {
                                'is-invalid': $setup.error.isError && $setup.error.passField
                            }
                        ]),
                        placeholder: "Password",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.password = $event),
                        onKeyup: _cache[3] || (_cache[3] = (0, $fkb2R.withKeys)(($event)=>$setup.submit(), [
                            "enter"
                        ]))
                    }, null, 34), [
                        [
                            (0, $fkb2R.vModelText),
                            $setup.password
                        ]
                    ]),
                    _cache[6] || (_cache[6] = (0, $fkb2R.createElementVNode)("div", {
                        class: "invalid-feedback"
                    }, " Please provide a password. ", -1))
                ]),
                _cache[7] || (_cache[7] = (0, $fkb2R.createElementVNode)("p", {
                    class: "text-center text-muted",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#forgotModal",
                    style: {
                        "cursor": "pointer"
                    }
                }, " Forgot Password? Click Here ", -1))
            ])
        ]),
        (0, $fkb2R.createElementVNode)("div", $3c26e4c0252b9aca$var$_hoisted_11, [
            (0, $fkb2R.createElementVNode)("button", {
                class: "btn btn-primary mt-2 mb-4",
                type: "button",
                disabled: $setup.submitting,
                onClick: $setup.submit
            }, [
                _cache[8] || (_cache[8] = (0, $fkb2R.createTextVNode)(" Login ", -1)),
                (0, $fkb2R.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm",
                    role: "status",
                    "aria-hidden": "true",
                    hidden: !$setup.submitting
                }, null, 8, $3c26e4c0252b9aca$var$_hoisted_13)
            ], 8, $3c26e4c0252b9aca$var$_hoisted_12)
        ])
    ], 2);
}

});

parcelRegister("5fkK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1e715d005b3cd8$export$2e2bcd8739ae039; });
let $3d1e715d005b3cd8$var$NOOP = ()=>{};
var $3d1e715d005b3cd8$export$2e2bcd8739ae039 = (script)=>{};

});

var $ba9adf01096e0c31$exports = {};
$parcel$extendImportMap({
    "a7Yvi": "person-square.1c9de0a8.svg",
    "1WStY": "shield-lock-fill.1a5df0eb.svg"
});


var $fkb2R = parcelRequire("fkb2R");
let $a64869e0055abe57$var$script;



let $a64869e0055abe57$var$initialize = ()=>{
    $a64869e0055abe57$var$script = (parcelRequire("1WtUB"));
    if ($a64869e0055abe57$var$script.__esModule) $a64869e0055abe57$var$script = $a64869e0055abe57$var$script.default;
    $a64869e0055abe57$var$script.render = (parcelRequire("5abBZ")).render;
    (parcelRequire("5fkK3")).default($a64869e0055abe57$var$script);
    $a64869e0055abe57$var$script.__scopeId = 'data-v-f7bcb7';
    $a64869e0055abe57$var$script.__file = "loginPage.vue";
};
$a64869e0055abe57$var$initialize();
var $a64869e0055abe57$export$2e2bcd8739ae039 = $a64869e0055abe57$var$script;



var $18pgY = parcelRequire("18pgY");
(0, $fkb2R.createApp)((0, $a64869e0055abe57$export$2e2bcd8739ae039)).mount("#app");
(0, $fkb2R.createApp)((0, $18pgY.default)).mount("#jsLoader");


//# sourceMappingURL=login.0e35fb7a.js.map
